// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/search.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/open-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/edit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/add.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard collapsible panel - slides down from top */
.dashboard_panel{
    max-height: 0;
    overflow: hidden;
    transition: none;
    background: linear-gradient(0deg, #f9f9f6, #fff);
}

.dashboard_panel--visible{
    max-height: 5000px;
    height: 100%;
    transition: max-height 400ms ease-in-out;
}

.dashboard_panel_content{
    display: flex;
    padding: 7px;
    padding-top: 12px;
    padding-bottom: 20px;
    gap: 7px;
    height: 100%;
}

/* Base widget block styling */
.dashboard_main_block{
    background: #FFFFFF;
    box-shadow: 0px 0px 10px rgba(140, 173, 255, 0.1);
    border-radius: 20px;
    padding: 17px;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.dashboard_main_block_head{
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    gap: 11px;
    flex-shrink: 0;
}

.dashboard_main_block_head_right{
    display: flex;
    justify-content: flex-end;
    gap: 11px;
}

.dashboard_main_block_title{
    font-weight: 700;
    font-size: calc(14px * var(--fontScaler));
    line-height: 24px;
    padding-left: 14px;
    color: #000000;
}

.dashboard_main_block_search_button{
    width: 24px;
    height: 24px;
    border-radius: 100%;
    /*background-color: #0009;*/
    flex-shrink: 0;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 16px;
    background-position: center;
    background-repeat: no-repeat;
}

.dashboard_main_block_link{
    font-style: italic;
    font-weight: 400;
    font-size: calc(12px * var(--fontScaler));
    line-height: 24px;
    text-decoration-line: underline;
    color: #979797;
}

.dashboard_main_block_open_button{
    width: 24px;
    height: 24px;
    border-radius: 100%;
    /*background-color: #0009;*/
    flex-shrink: 0;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: 10px;
    background-position: center;
    background-repeat: no-repeat;
}

.dashboard_main_block_edit_button{
    width: 24px;
    height: 24px;
    border-radius: 100%;
    /*background-color: #0009;*/
    flex-shrink: 0;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: 10px;
    background-position: center;
    background-repeat: no-repeat;
}

.dashboard_main_analysis_add{
    display: flex;
    gap: 5px;
    margin-top: 22px;
    flex-shrink: 0;
    cursor: pointer;
    user-select: none;
}

.dashboard_main_analysis_add_icon{
    width: 15px;
    height: 15px;
    border-radius: 100%;
    /*background-color: #0009;*/
    flex-shrink: 0;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: 12.5px;
    background-position: center;
    background-repeat: no-repeat;
}

.dashboard_main_analysis_add_text{
    font-size: calc(12px * var(--fontScaler));
    transition: color 150ms ease-in-out;
}

.dashboard_main_analysis_add:hover .dashboard_main_analysis_add_text{
    color: #f90;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/DashboardList.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,QAAQ;IACR,YAAY;AAChB;;AAEA,8BAA8B;AAC9B;IACI,mBAAmB;IACnB,iDAAiD;IACjD,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;;IAEd,yDAAgD;IAChD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;;IAEd,yDAAoD;IACpD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;;IAEd,yDAA8C;IAC9C,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;;IAEd,yDAA6C;IAC7C,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,yCAAyC;IACzC,mCAAmC;AACvC;;AAEA;IACI,WAAW;AACf","sourcesContent":["/* Dashboard collapsible panel - slides down from top */\n.dashboard_panel{\n    max-height: 0;\n    overflow: hidden;\n    transition: none;\n    background: linear-gradient(0deg, #f9f9f6, #fff);\n}\n\n.dashboard_panel--visible{\n    max-height: 5000px;\n    height: 100%;\n    transition: max-height 400ms ease-in-out;\n}\n\n.dashboard_panel_content{\n    display: flex;\n    padding: 7px;\n    padding-top: 12px;\n    padding-bottom: 20px;\n    gap: 7px;\n    height: 100%;\n}\n\n/* Base widget block styling */\n.dashboard_main_block{\n    background: #FFFFFF;\n    box-shadow: 0px 0px 10px rgba(140, 173, 255, 0.1);\n    border-radius: 20px;\n    padding: 17px;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.dashboard_main_block_head{\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 12px;\n    gap: 11px;\n    flex-shrink: 0;\n}\n\n.dashboard_main_block_head_right{\n    display: flex;\n    justify-content: flex-end;\n    gap: 11px;\n}\n\n.dashboard_main_block_title{\n    font-weight: 700;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 24px;\n    padding-left: 14px;\n    color: #000000;\n}\n\n.dashboard_main_block_search_button{\n    width: 24px;\n    height: 24px;\n    border-radius: 100%;\n    /*background-color: #0009;*/\n    flex-shrink: 0;\n\n    background-image: url('../../assets/search.svg');\n    background-size: 16px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.dashboard_main_block_link{\n    font-style: italic;\n    font-weight: 400;\n    font-size: calc(12px * var(--fontScaler));\n    line-height: 24px;\n    text-decoration-line: underline;\n    color: #979797;\n}\n\n.dashboard_main_block_open_button{\n    width: 24px;\n    height: 24px;\n    border-radius: 100%;\n    /*background-color: #0009;*/\n    flex-shrink: 0;\n\n    background-image: url('../../assets/open-arrow.svg');\n    background-size: 10px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.dashboard_main_block_edit_button{\n    width: 24px;\n    height: 24px;\n    border-radius: 100%;\n    /*background-color: #0009;*/\n    flex-shrink: 0;\n\n    background-image: url('../../assets/edit.svg');\n    background-size: 10px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.dashboard_main_analysis_add{\n    display: flex;\n    gap: 5px;\n    margin-top: 22px;\n    flex-shrink: 0;\n    cursor: pointer;\n    user-select: none;\n}\n\n.dashboard_main_analysis_add_icon{\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    /*background-color: #0009;*/\n    flex-shrink: 0;\n\n    background-image: url('../../assets/add.svg');\n    background-size: 12.5px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.dashboard_main_analysis_add_text{\n    font-size: calc(12px * var(--fontScaler));\n    transition: color 150ms ease-in-out;\n}\n\n.dashboard_main_analysis_add:hover .dashboard_main_analysis_add_text{\n    color: #f90;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
